export enum AllCasesEventType {
  CaseUpdated = 'CaseUpdated',
}

export enum AllCasesGroupEventType {
  JoinAllCasesGroup = 'JoinAllCasesGroup',
  LeaveAllCasesGroup = 'LeaveAllCasesGroup',
}

export type WsAllCasesEventMessageContent = {
  CaseId: string;
};
